<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import RedSpot from '@/components/RedSpot.vue';
import Card from '@/components/cards/Card.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  hasTitle,
  description,
  hasDescription,
  items,
  hasItems,
  columnsCount,
  redSpot,
  hasRedSpot,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <RedSpot
      v-if="hasRedSpot"
      :position-vertical="redSpot.vertical"
      :position-horizontal="redSpot.horizontal"
    />
    <div class="container">
      <div
        class="cards"
        :class="[backgroundColor === 'black' ? 'white' : 'black']"
      >
        <div class="cards__top text-center">
          <h2
            v-if="hasTitle"
            class="mb-0 cards__title h2"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="title"
          ></h2>
          <div
            v-if="hasDescription"
            class="mb-0 cards__description body-1-regular"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="description"
          ></div>
        </div>
        <div
          v-if="hasItems"
          :class="[`cards__items cards__items--${columnsCount}`]"
        >
          <Card
            v-for="(item, index) in items"
            :key="index"
            :title="item?.title"
            :image="item?.image"
            :description="item?.description"
            :theme="backgroundColor"
            data-aos="fade-up"
            :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.cards {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__title {
    margin: 0;
    @include media-breakpoint-up(md) {
      max-width: 50%;
      margin: 0 auto;
    }
  }
  &__description {
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
    @include media-breakpoint-up(md) {
      max-width: 50%;
      margin: 0 auto;
    }
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      &--3 {
        grid-template-columns: repeat(3, 1fr);
      }
      &--4 {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
}
</style>
